import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { scrollToElement } from '../utils/helpers';
import { applySeo } from '../utils/seo';

import Hero from '../sections/Hero';
import WhatAreInsoles from '../sections/WhatAreInsoles';
import HowWeWork from '../sections/HowWeWork';
import Products from '../sections/Products';
import ProductsCatalog from '../sections/ProductsCatalog';
import WhyChooseUs from '../sections/WhyChooseUs';
import AboutVideo from '../sections/AboutVideo';
import FAQ from '../sections/FAQ';
import Testimonials from '../sections/Testimonials';
import InstagramReels from '../sections/InstagramReels';
import ContactForm from '../sections/ContactForm';
import Contacts from '../sections/Contacts';

const HomePage = () => {
    const location = useLocation();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        applySeo({
            language: i18n.language,
            path: '/',
            title: t('seo.home.title'),
            description: t('seo.home.description')
        });
    }, [i18n.language, t]);

    useEffect(() => {
        const hash = location.hash?.replace(/^#/, '');
        if (!hash) return undefined;
        const id = setTimeout(() => {
            scrollToElement(hash);
        }, 80);
        return () => clearTimeout(id);
    }, [location]);

    return (
        <>
            <Hero />
            <WhatAreInsoles />
            <HowWeWork />
            <Products />
            <ProductsCatalog />
            <WhyChooseUs />
            <AboutVideo />
            <Testimonials />
            <InstagramReels />
            <FAQ />
            <ContactForm />
            <Contacts />
        </>
    );
};

export default HomePage;
